var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgReview({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "18px",
    height: "18px",
    viewBox: "0 0 18 18",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "clock") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "clock",
    fill: "#000000",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9,0 C4.02977726,0 0,4.02977726 0,9 C0,13.9702227 4.02977726,18 9,18 C13.9702227,18 18,13.9702227 18,9 C18,4.02977726 13.9702227,0 9,0 Z M9,17.2501758 C4.45111372,17.2501758 0.74982415,13.5495897 0.74982415,9 C0.74982415,4.45041032 4.45041032,0.74982415 9,0.74982415 C13.5495897,0.74982415 17.2501758,4.45041032 17.2501758,9 C17.2501758,13.5488863 13.5495897,17.2501758 9,17.2501758 Z",
    id: "Shape"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    points: "9 9.74982415 4.4996483 9.74982415 4.4996483 10.4996483 9.74982415 10.4996483 9.74982415 3.03024619 9 3.03024619"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReview);
export default __webpack_public_path__ + "static/media/Review.db92c920c6ea6bc2d3522c7f1b42a6fe.svg";
export { ForwardRef as ReactComponent };